import { render, staticRenderFns } from "./Klien.vue?vue&type=template&id=6c50dc68&scoped=true&"
import script from "./Klien.vue?vue&type=script&lang=js&"
export * from "./Klien.vue?vue&type=script&lang=js&"
import style0 from "./Klien.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Klien.vue?vue&type=style&index=1&id=6c50dc68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c50dc68",
  null
  
)

export default component.exports